import { ControlValidator } from './control.validator';
import { StringSignal } from '../../../../application/controls/string-signal';
import { Problem, Validatable, ValidationTrigger } from '../validator';

export class StringSignalValidator extends ControlValidator {
  public isRelevant(node: Validatable, triggers: ValidationTrigger[]): boolean {
    return (
      node instanceof StringSignal &&
      (triggers.includes('nodeProperties') || triggers.includes('signals') || triggers.includes('applicationWide'))
    );
  }

  public validate(control: StringSignal): Problem[] {
    return [
      ...this.validateControl(control),
      ...this.validateSignalId(control.signalId, control.humanReadableName, 'signalId', this.systemIndex),
    ];
  }
}
